import type { BabyEntryPage, Channel } from "@/api_client";
import { BabyEntryForm } from "@/components/products/baby/entry/BabyEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type BabyEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function BabyEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<BabyEntryProps>) {
  const {
    isLoading,
    isSubmitting,
    submitEntryHandler,
    policyHolder,
    user,
    content,
  } = useEntryForWebComponents<BabyEntryPage>({
    productType: "baby",
    backendHost,
    appPathPrefix,
    skipCart,
    channel,
    contentPageKey: "babyEntryPage",
    language,
  });

  if (isLoading) return <ProductContainer.Loader />;

  return (
    <BabyEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
